import { gsap } from "gsap";

document.addEventListener("DOMContentLoaded", () => {
  const blocks = document.querySelectorAll(".video-card");

  blocks.forEach((block) => {
    const trigger = block.querySelector("[data-video-player]");
    const videoWrapper = block.querySelector(".wp-block-video");
    if (!trigger || !videoWrapper) return;
    const video = videoWrapper.querySelector("video");
    if (!video) return;

    trigger.addEventListener("click", () => {
      const lightbox = document.createElement("div");
      lightbox.classList.add("video-card__lightbox");
      lightbox.setAttribute("data-video-lightbox", "");
      const closeIconUrl = block.dataset.closeIcon || "";
      lightbox.innerHTML = `
        <div class="video-card__lightbox__content">
          <div class="video-card__lightbox__head">
            <div class="video-card__lightbox__head__container">
              <button type="button" class="video-card__lightbox__close" data-video-lightbox-close aria-label="Cerrar">
                <span class="video-card__lightbox__close__label">Cerrar</span>
                <img class="video-card__lightbox__close__icon" src="${closeIconUrl}" alt="" aria-hidden="true">
              </button>
            </div>
          </div>
          <div class="video-card__lightbox__body container">
            <div data-video-lightbox-wrapper>
              ${video.outerHTML}
            </div>
          </div>
        </div>
      `;

      document.body.appendChild(lightbox);

      const close = lightbox.querySelector("[data-video-lightbox-close]");
      const wrapper = lightbox.querySelector("[data-video-lightbox-wrapper]");
      const videoLightbox = lightbox.querySelector("video");
      const triggerRect = () => trigger.getBoundingClientRect();
      const bodyRect = () =>
        lightbox
          .querySelector(".video-card__lightbox__body")
          .getBoundingClientRect();

      videoLightbox.controls = true;
      videoLightbox.loop = true;
      videoLightbox.playsInline = true;
      // Intentamos play() con sonido: el click es una user activation
      // activa, así que los navegadores deberían permitirlo. Si por
      // política del navegador se rechaza, volvemos a intentar muted.
      videoLightbox.muted = false;
      videoLightbox.volume = 0;
      videoLightbox.play().catch(() => {
        videoLightbox.muted = true;
        videoLightbox.play().catch((err) => {
          console.error("El autoplay no funcionó:", err);
        });
      });

      // Fade-in de volumen en paralelo a la animación de apertura.
      gsap.to(videoLightbox, {
        volume: 1,
        duration: 0.8,
        delay: 0.3,
        ease: "power2.out",
      });

      gsap.fromTo(
        wrapper,
        {
          position: "fixed",
          top: `${triggerRect().y}px`,
          left: `${triggerRect().x}px`,
          width: `${triggerRect().width}px`,
          maxHeight: `${triggerRect().height}px`,
          borderRadius: `${window.getComputedStyle(videoWrapper).borderRadius}`,
        },
        {
          top: `${bodyRect().y}px`,
          left: `${bodyRect().x}px`,
          width: `${bodyRect().width}px`,
          maxHeight: `${bodyRect().height}px`,
          aspectRatio: 16 / 9,
          duration: 0.8,
          ease: "expo.inOut",
          borderRadius: 0,
          delay: 0.3,
          onComplete: function () {
            gsap.set(wrapper, { clearProps: "all" });
          },
        }
      );

      const closeLightbox = () => {
        // Fade-out de volumen en paralelo a la animación de cierre.
        gsap.to(videoLightbox, {
          volume: 0,
          duration: 0.5,
          ease: "power2.in",
        });

        gsap.fromTo(
          wrapper,
          {
            position: "fixed",
            top: `${bodyRect().y}px`,
            left: `${bodyRect().x}px`,
            width: `${bodyRect().width}px`,
            maxHeight: `${bodyRect().height}px`,
            aspectRatio: 16 / 9,
          },
          {
            position: "fixed",
            top: `${triggerRect().y}px`,
            left: `${triggerRect().x}px`,
            width: `${triggerRect().width}px`,
            maxHeight: `${triggerRect().height}px`,
            duration: 0.5,
            ease: "power2.inOut",
            onStart: () => {
              videoLightbox.controls = false;
              videoLightbox.loop = false;
            },
            onComplete: () => {
              videoLightbox.pause();
              if (lightbox.parentNode) {
                document.body.removeChild(lightbox);
              }
            },
          }
        );
      };

      close.addEventListener("click", closeLightbox);

      lightbox.addEventListener("click", (e) => {
        if (e.target === lightbox) closeLightbox();
      });
    });
  });
});
